<template>
  <div class="hp-manager-page-list">
    <filter-from :filter='filter' @handleSubmit="handleSubmit">
      <!-- <span v-if="permissionChecker('Employee.Create')" slot="button">
        <a-button type="primary" @click="handleEdit(0)">新增</a-button>
      </span> -->
    </filter-from>
    <standard-table ref="datas" size="default" :bordered="true" :columns="columns" :dataSource="datas" :pagination="pagination" :loading="loading" @tableChange="tableChange">
      <!-- <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a :disabled="!permissionChecker('Employee.Edit')" @click="handleEdit(1,rowKey.data)">编辑</a>
          <a-divider type="vertical" />
          <a :disabled="!permissionChecker('Employee.Delete')" @click="deldata(rowKey.data)">删除</a>
        </span>
      </template> -->
      <template slot="statusSwitch" slot-scope="rowKey">
        <a-switch v-model="rowKey.data.isActive" :disabled="true" />
      </template>

    </standard-table>

    <!-- 新增修改弹窗 -->
    <hp-manager-modal :width="modalWidth" :title="title" v-model="addVisible">
      <hp-manager-page-Employee-add slot="slot" @submit-success="refreshCurrent" @cancel="addVisible = false" :params="params"></hp-manager-page-Employee-add>
    </hp-manager-modal>

  </div>
</template>


<script>
import { api } from "@/common";
import filterFrom from "@/components/filter/filter";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageEmployeeAdd from "./Add";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    filterFrom,
    hpManagerPageEmployeeAdd
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "name",
          name: "姓名"
        },
        {
          type: "input",
          key: "code",
          name: "员工编号"
        },
        {
          type: "input",
          key: "telephone",
          name: "电话"
        }
      ],
      columns: [
        // {
        //   title: "操作",
        //   dataIndex: "action",
        //   width: 120,
        //   scopedSlots: { customRender: "action" },
        //   fixed: "left"
        // },
        {
          title: "姓名",
          dataIndex: "name",
          sorter: true
        },
        {
          title: "电话",
          dataIndex: "telephone",
          width: 150
        },
        {
          title: "员工编号",
          dataIndex: "code",
          width: 150
        },
        {
          title: "销售组织",
          dataIndex: "organizationName",
          width: 250
        },
        // {
        //   title: "部门",
        //   dataIndex: "departmentName",
        //   width: 200
        // },
        {
          title: "状态",
          width: 150,
          dataIndex: "status",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "修改时间",
          dataIndex: "lastModificationTime",
          width: 150,
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { name: "", isActive: null },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "400px",
      selectedRowKeys: [],
      rowSelection: null,
      title: ""
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.name = p.values.name;
      this.filterdata.code = p.values.code;
      this.filterdata.telephone = p.values.telephone;
      this.filterdata.isActive =
        p.values.isActive == 1 ? true : p.values.isActive == 0 ? false : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    async activeChange(record) {
      let active = await api.ActiveEmployee({ id: record.id });
    },
    //弹出编辑 详情 新增 模态框
    handleEdit(type, record) {
      this.isabl = false;
      if (type == 1) {
        this.title = "编辑员工";
      } else if (type == 2) {
        this.title = "员工详情";
        this.isabl = true;
      } else {
        this.title = "新增员工";
      }
      this.params = Object.assign({ isShow: this.isabl }, record);
      this.addVisible = true;
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DelEmployee({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },

    refreshCurrent() {
      this.pagination.current = 0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetEmployeeList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/router/Basic/Employee/List.vue